import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, [
    _createVNode("path", {
      "fill-rule": "evenodd",
      d: "M7.5 7.5v9h9v-9h-9zM12 14c.37 0 .718-.101 1.016-.277l1.13 1.13a.5.5 0 00.708-.707l-1.13-1.13c.175-.298.276-.645.276-1.016 0-.37-.101-.718-.277-1.016l1.13-1.13a.5.5 0 00-.707-.708l-1.13 1.13A1.991 1.991 0 0012 10c-.37 0-.718.101-1.016.277l-1.13-1.13a.5.5 0 10-.708.707l1.13 1.13A1.991 1.991 0 0010 12c0 .37.101.718.277 1.016l-1.13 1.13a.5.5 0 00.707.708l1.13-1.13c.298.175.645.276 1.016.276z",
      "clip-rule": "evenodd"
    }),
    _createVNode("path", {
      "fill-rule": "evenodd",
      d: "M5 6a1 1 0 011-1h12a1 1 0 011 1v11.935a1 1 0 01-1 1H6a1 1 0 01-1-1V6zm1.5 1a.5.5 0 01.5-.5h10a.5.5 0 01.5.5v10a.5.5 0 01-.5.5H7a.5.5 0 01-.5-.5V7z",
      "clip-rule": "evenodd"
    }),
    _createVNode("circle", {
      cx: "12",
      cy: "12",
      r: "1"
    }),
    _createVNode("path", { d: "M7 19h2v.578a.422.422 0 01-.422.422H7.422A.422.422 0 017 19.578V19zM15 19h2v.578a.422.422 0 01-.422.422h-1.156a.422.422 0 01-.422-.422V19z" })
  ]))
}